var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-container',[_c('WebReport',{attrs:{"url":_vm.url,"params":_vm.params,"roomName":_vm.roomName,"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }